/* The Paperboat Shop - Gift wrapping add-on.
   Per item: $5 for each individual item, $8 for each bundle.
   A cart attribute (gift_wrap=on) remembers the choice; wrap quantities auto-match the cart. */
(function () {
  if (window.__pbGiftWrap) return;
  window.__pbGiftWrap = true;

  var STD_ID = 48815309947135; // $5 - per individual item
  var BUN_ID = 48815309979903; // $8 - per bundle
  var WRAP_IDS = [STD_ID, BUN_ID];
  var BUNDLE_PRODUCT_IDS = [9500805366015, 9500788818175, 9500788883711];

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function updateAttrs(a) { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) }); }
  function change(id, q) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: String(id), quantity: q }) }); }
  function add(id, q) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: q }] }) }); }

  function isBundle(i) { return BUNDLE_PRODUCT_IDS.indexOf(i.product_id) >= 0; }
  function isWrap(i) { return WRAP_IDS.indexOf(i.variant_id) >= 0; }
  function isOn(cart) { return !!(cart.attributes && String(cart.attributes.gift_wrap) === 'on'); }

  function counts(cart) {
    var std = 0, bun = 0;
    (cart.items || []).forEach(function (i) { if (isWrap(i)) return; if (isBundle(i)) bun += i.quantity; else std += i.quantity; });
    return { std: std, bun: bun };
  }
  function wrapQty(cart) {
    var std = 0, bun = 0;
    (cart.items || []).forEach(function (i) { if (i.variant_id === STD_ID) std = i.quantity; if (i.variant_id === BUN_ID) bun = i.quantity; });
    return { std: std, bun: bun };
  }

  function syncQuantities(cart) {
    var c = counts(cart), w = wrapQty(cart), changed = false, p = Promise.resolve();
    if (w.std !== c.std) { changed = true; p = p.then(function () { return (w.std === 0 && c.std > 0) ? add(STD_ID, c.std) : change(STD_ID, c.std); }); }
    if (w.bun !== c.bun) { changed = true; p = p.then(function () { return (w.bun === 0 && c.bun > 0) ? add(BUN_ID, c.bun) : change(BUN_ID, c.bun); }); }
    return p.then(function () { return changed; });
  }
  function removeWraps(cart) {
    var w = wrapQty(cart), p = Promise.resolve();
    if (w.std > 0) p = p.then(function () { return change(STD_ID, 0); });
    if (w.bun > 0) p = p.then(function () { return change(BUN_ID, 0); });
    return p;
  }

  function turnOn() { return updateAttrs({ gift_wrap: 'on' }).then(getCart).then(function (cart) { return syncQuantities(cart); }); }
  function turnOff() { return updateAttrs({ gift_wrap: 'off' }).then(getCart).then(function (cart) { return removeWraps(cart); }); }

  function buildToggle(context) {
    var box = document.createElement('div');
    box.setAttribute('data-gift-wrap-addon', context);
    box.style.cssText = 'display:flex;align-items:flex-start;gap:.65rem;margin:1rem 0;padding:1rem 1.1rem;border:1px solid #e2d9cb;border-radius:10px;background:#faf7f2;';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'js-gift-wrap-toggle';
    cb.id = 'GiftWrap-' + context + '-' + Math.random().toString(36).slice(2, 7);
    cb.style.cssText = 'width:26px;height:26px;margin-top:2px;flex:0 0 auto;';
    var label = document.createElement('label');
    label.setAttribute('for', cb.id);
    label.style.cssText = 'cursor:pointer;font-size:1.35rem;line-height:1.45;';
    label.innerHTML = '🎁 Add gift wrapping — <strong>$5 per item</strong> ($8 per bundle). Each item is wrapped individually.<br><span style="font-size:1.1rem;color:#666;">Only want <em>one</em> item wrapped? Add it here, then note which item in the order notes at checkout.</span>';
    box.appendChild(cb);
    box.appendChild(label);
    cb.addEventListener('change', function () {
      cb.disabled = true;
      (cb.checked ? turnOn() : turnOff()).then(function () { window.location.reload(); }).catch(function () { cb.disabled = false; });
    });
    return box;
  }

  function injectAll() {
    document.querySelectorAll('product-form .product-form__buttons').forEach(function (btns) {
      var form = btns.closest('product-form');
      if (!form || form.querySelector('[data-gift-wrap-addon]')) return;
      if (form.closest('.card, quick-add-modal, .quick-add, .card-wrapper')) return;
      btns.parentNode.insertBefore(buildToggle('product'), btns);
    });
    document.querySelectorAll('.drawer__footer, .cart__footer, cart-drawer .drawer__footer').forEach(function (footer) {
      if (footer.querySelector('[data-gift-wrap-addon]')) return;
      footer.insertBefore(buildToggle('cart'), footer.firstChild);
    });
  }

  function reconcile(allowReload) {
    getCart().then(function (cart) {
      var on = isOn(cart);
      if (on) {
        var c = counts(cart), w = wrapQty(cart);
        if (allowReload && (w.std !== c.std || w.bun !== c.bun)) {
          syncQuantities(cart).then(function (changed) { if (changed) window.location.reload(); });
          return;
        }
      } else {
        var w2 = wrapQty(cart);
        if (allowReload && (w2.std > 0 || w2.bun > 0)) { removeWraps(cart).then(function () { window.location.reload(); }); return; }
      }
      document.querySelectorAll('.js-gift-wrap-toggle').forEach(function (cb) { cb.checked = on; });
    }).catch(function () {});
  }

  function init() { try { injectAll(); reconcile(true); } catch (e) {} }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('click', function () { setTimeout(function () { try { injectAll(); reconcile(false); } catch (e) {} }, 350); });
})();
